export const templateCategories = [
  "identification",
  "defect",
  "compliance",
] as const;
